import React, { useState, useEffect } from 'react';
import { Row } from 'react-bootstrap';
import HVASystemKPICard1Inbound from 'components/cards/HVASystemKPICard1Inbound';
import HVASystemKPICard2 from 'components/cards/HVASystemKPICard2';
import {
  fetchHVACallingTodayKPIsInbound,
  FetchHVACallingTodayKPIsParams
} from 'services/hvacallingmanagment.service';
import {
  faComments,
  faPeopleArrows,
  faVolumeControlPhone,
  faPhoneSlash,
  faCommenting
} from '@fortawesome/free-solid-svg-icons';

// Definir la estructura de los KPIs
interface HVACallingKPIs {
  actualcalls: number;
  offered: number;
  dropped: number;
  handled: number;
  talktime: number;
}

// Props del componente con un parámetro opcional campaignid
interface ActualCallingKPIsProps {
  campaignid?: number;
}

const ActualCallingKPIsInbound: React.FC<ActualCallingKPIsProps> = ({
  campaignid
}) => {
  // Estado para almacenar los KPIs
  const [kpis, setKpis] = useState<HVACallingKPIs>({
    actualcalls: 0,
    offered: 0,
    dropped: 0,
    handled: 0,
    talktime: 0
  });

  useEffect(() => {
    // Función para obtener los KPIs de hoy
    const getKPIs = async () => {
      try {
        const params: FetchHVACallingTodayKPIsParams = { campaign: campaignid };
        const response = await fetchHVACallingTodayKPIsInbound(params);
        setKpis(response);
      } catch (error) {
        console.error('Error fetching KPIs:', error);
      }
    };

    // Llamada a la función al montar el componente y luego cada 5 segundos
    getKPIs();
    const intervalId = setInterval(getKPIs, 5000);

    // Limpiar el intervalo cuando el componente se desmonta
    return () => clearInterval(intervalId);
  }, [campaignid]);

  // Verificación de divisiones por cero
  // eslint-disable-next-line
  const safeDivide = (numerator: number, denominator: number) => (denominator !== 0 ? numerator / denominator : 0);

  return (
    <>
      <Row className="align-items-center mb-1 align-content-between">
        <HVASystemKPICard1Inbound
          icon={faCommenting}
          color="white"
          label="Actual calls"
          value={kpis.actualcalls}
          value2={
            kpis.offered > 0 ? safeDivide(kpis.handled, kpis.offered) * 100 : 0
          } // Evita división por 0
          value3={
            kpis.offered > 0 ? safeDivide(kpis.talktime / 60, kpis.offered) : 0
          } // Evita división por 0; talktime está en segundos y se convierte a minutos
          title="Connected"
        />
      </Row>
      <Row className="align-items-center mb-1 align-content-between">
        <HVASystemKPICard2
          icon={faVolumeControlPhone}
          color="primary-dark"
          label="Today"
          value={kpis.offered}
          title="Offered"
        />
      </Row>
      <Row className="align-items-center mb-1 align-content-between">
        <HVASystemKPICard2
          icon={faPhoneSlash}
          color="primary-dark"
          label="Today"
          value={kpis.dropped}
          title="Dropped"
        />
      </Row>
      <Row className="align-items-center mb-1 align-content-between">
        <HVASystemKPICard2
          icon={faPeopleArrows}
          color="primary-dark"
          label="Today"
          value={kpis.handled}
          title="Handled"
        />
      </Row>
      <Row className="align-items-center mb-0 align-content-between">
        <HVASystemKPICard2
          icon={faComments}
          color="primary-dark"
          label="Today"
          value={kpis.talktime / 3600} // talktime está en segundos y se convierte a horas
          title="Talk time"
        />
      </Row>
    </>
  );
};

export default ActualCallingKPIsInbound;
